import React from 'react';
import { I18n } from 'react-redux-i18n';

const styleParent = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
};
const style = {
	fontSize: 20,
	fontWeight: 'bold',
	backgroundColor: '#e6e6e6',
	textAlign: 'center',
	padding: '5px 10px',
	borderRadius: 5,
	cursor: 'pointer',
};

const style2 = {
	fontWeight: 'lighter',
	fontStyle: 'italic',
};
const CopyToken = ({ label, token }) => {
	const copyToken = async value => {
		await navigator.clipboard.writeText(value);
		alert(I18n.t('partner.copied'));
	};

	return (
		<div style={styleParent}>
			<p>{label} :</p>

			<p style={style} onClick={() => copyToken(token)}>
				<span>{token}</span>
			</p>
			<p style={style2} onClick={() => copyToken(token)}>
				{I18n.t('partner.copy')}
			</p>
		</div>
	);
};

export default CopyToken;
